<template>
  <div class="card-component"
       :class="[
          `size-${size}`
        ]"
  >
    <h1 class="card-header"
        v-if="title"
    >
      {{ title }}
      <ym-icon v-if="icon"
                class="icon-tick-round ym-icon"
                :name="icon"
      />
    </h1>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      title: {
        type: String,
      },
      icon: {
        type: String,
      },
      size: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'normal',
            'large',
          ].includes(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .card-component {
    text-align: center;
    border-radius: @border-radius-medium;
    background-color: @color-white;
    padding: @size-extra-medium @size-base @size-medium;
    &.size-large {
      padding: @size-large @size-base;
      .card-header {
        font-size: @font-size-extra-extra-large;
        padding-bottom: @size-large;
        margin-bottom: @size-extra-large;
      }
    }
  }

  .card-header {
    line-height: 1;
    border-bottom: @border-base;
    font-size: @font-size-large;
    padding-bottom: @size-medium;
    margin: 0 0 @size-extra-medium;
  }

  .ym-icon {
    color: @color-primary;
    margin-left: @size-base;
  }

  .icon-tick-round {
    font-size: 50px;
  }

</style>
